import { Button } from "@dune/ui";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const GoBackButton = () => {
	const navigate = useNavigate();

	return (
		<Button
			variant="ghost"
			onClick={() => navigate(-1)}
			className="has-[>svg]:px-1"
		>
			<ArrowLeft />
			Retour
		</Button>
	);
};
